<template>
  <div class="additem-step-box">
    <div class="content">
      <div class="content-box">
        <!--
          serviceType 任务类型
            配置更新  1
            服务下发  2

          commandMode  1-服务.提示确认，2-服务.状态更改，3-服务.弹框录入，4-配置.表单录入，5-配置.数据存档，6-配置.历史选择
          command_status_type   1-机器锁，2-省电模式，3-自由锁，4-账单锁，5-库存锁
          command_status_dic_group    命令状态字典项（用于显示状态的样式）
          是否在线 dataValue==='0'
          字典
            命令模式  topic_command_mode
            命令状态类型  command_status_type
         -->
        <el-form :model="form" ref="form" label-position="top" label-width="120px">
          <!-- 刷新topic小类 -->
          <!-- <template v-if="data.topicCode==='serviceRefreshTopic'">
              <el-row :gutter="20" :span="24">
                <template v-for="(item, index) in topicCodeList">
                  <el-form-item :label="item.dataName" prop="parentId" :key="index">
                    <custom-select
                      v-model="item.paramValue"
                      :key="index"
                      :placeholder="$t('com_please_select"
                      :props="{ label: 'topicName', value: 'topicCode' }"
                      url="TopicPublishList"
                      :show-all-levels="false"
                      :params="{productCode : data.productCode, protocolId : data.protocolId, tcpVersion: data.tcpVersion ,topicClass: ['11','12','40'], }"
                      width="350px"
                    ></custom-select>
                  </el-form-item>
                </template>
              </el-row>
          </template> -->
          <!-- 服务下发 -->
          <template v-if="data.serviceType === '2' && topicCodeList[0] && `${topicCodeList[0].commandMode}` === '1'">
            <!-- <div class="title" v-if="data.topicDesc" >
              <i class="icon icon-tishi"></i>
              {{data.topicDesc}}
            </div> -->

            <template v-for="(item, index) in topicCodeList">
              <!--
                  widgetType控件类型，1-文本框、2-下拉框、3-复选、4-单选、5-时间控件、6-数字 7-开关等
                  控件是否可编辑，1-可编辑，0-不可编辑
                -->
              <el-row :gutter="20" :span="24" :key="index" v-if="`${item.widgetType}` === '9'">
                <p class="topicCode-name">{{ item.dataName }}</p>
              </el-row>

              <el-row :gutter="20" :span="24" :key="index" v-else>
                <!-- <p class="topicCode-name">{{item.dataName}}</p> -->
                <costomWidget
                  :key="index"
                  v-model="item.paramValue"
                  :label="item.dataName"
                  :type="`${item.widgetType}`"
                  :isEditWidget="item.isEditWidget"
                  :dicGroup="item.dicGroup"
                  :showUnit="item.showUnit"
                  :dataLen="item.dataLen"
                  :dataType="item.dataType"
                  :topicTslGroup="item.topicTslGroup"
                  width="350px"
                ></costomWidget>
              </el-row>
            </template>
            <p class="subtitle">
              {{ data.topicDesc }}
            </p>
          </template>
          <!-- 状态修改 -->
          <template v-else-if="data.serviceType === '2' && topicCodeList[0] && `${topicCodeList[0].commandMode}` === '2'">
            <!-- 服务下发 -->
            <!-- <div class="title" v-if="data.topicDesc" >
              <i class="icon icon-tishi"></i>
              {{data.topicDesc}}
            </div> -->

            <template v-for="(item, index) in topicCodeList">
              <!--
                  widgetType控件类型，1-文本框、2-下拉框、3-复选、4-单选、5-时间控件、6-数字 7-开关等
                  控件是否可编辑，1-可编辑，0-不可编辑
                -->
              <el-row :gutter="20" :span="24" :key="index" v-if="`${item.widgetType}` === '9'">
                <p class="topicCode-name">{{ item.dataName }}</p>
              </el-row>

              <!-- <el-row :gutter="20" :span="24" :key="index" v-else>
                <costomWidget
                  :key="index"
                  v-model="item.paramValue"
                  :label='item.dataName'
                  :type="item.widgetType"
                  :isEditWidget='item.isEditWidget'
                  :dicGroup="item.dicGroup"
                  :showUnit="item.showUnit"
                  :dataLen="item.dataLen"
                  :topicTslGroup="item.topicTslGroup"
                  width="350px"
                >
                </costomWidget>
              </el-row> -->

              <el-row :gutter="20" :span="24" :key="index" v-else>
                <el-col :span="24">
                  <el-form-item :label="$t('dms_firmwareTask_instruction.qxxzyxcz')" prop="dataValue">
                    <!-- {{dictionary}} -->
                    <!-- <el-radio-group v-model="form.dataValue">
                      <el-radio :label="item.value" v-for="item in dictionary" :key="item.value">{{ item.name }}</el-radio>
                    </el-radio-group> -->
                    <el-radio-group v-model="item.paramValue" size="small" class="no-radio">
                      <el-radio border :label="item.value" v-for="item in dictionary" :key="item.value">{{ item.name }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <p class="subtitle">
              {{ data.topicDesc }}
            </p>
          </template>
          <!-- 修改配置 -->
          <template v-else>
            <!-- 修改配置 有分组-->
            <template v-if="classTslGroup.length">
              <el-row :gutter="20" :span="24" v-for="cItem in classTslGroup" :key="cItem.tslId" style="width: 760px">
                <div class="item-title">
                  {{ getDicValue('iot_topic_tsl_group', cItem) ? `${getDicValue('iot_topic_tsl_group', cItem)}` : '-' }}
                </div>
                <template v-for="(item, index) in topicCodeList">
                  <!--
                    widgetType控件类型，1-文本框、2-下拉框、3-复选、4-单选、5-时间控件、6-数字 7-开关等
                    控件是否可编辑，1-可编辑，0-不可编辑
                  -->
                  <costomWidget
                    v-if="item.topicTslGroup === cItem"
                    :key="index"
                    v-model="item.paramValue"
                    :label="item.dataName"
                    :type="`${item.widgetType}`"
                    :isEditWidget="item.isEditWidget"
                    :dicGroup="item.dicGroup"
                    :showUnit="item.showUnit"
                    :dataLen="item.dataLen"
                    :dataType="item.dataType"
                    :topicTslGroup="item.topicTslGroup"
                    width="350px"
                  ></costomWidget>
                </template>
              </el-row>
              <el-row :gutter="20" :span="24" v-if="otherParamList.length > 0">
                <template v-for="(item, index) in otherParamList">
                  <!--
                    widgetType控件类型，1-文本框、2-下拉框、3-复选、4-单选、5-时间控件、6-数字 7-开关等
                    控件是否可编辑，1-可编辑，0-不可编辑
                  -->
                  <costomWidget
                    :key="index"
                    v-model="item.paramValue"
                    :label="item.dataName"
                    :type="`${item.widgetType}`"
                    :isEditWidget="item.isEditWidget"
                    :dicGroup="item.dicGroup"
                    :showUnit="item.showUnit"
                    :dataLen="item.dataLen"
                    :dataType="item.dataType"
                    :topicTslGroup="item.topicTslGroup"
                    width="350px"
                  ></costomWidget>
                </template>
              </el-row>
            </template>
            <template v-else>
              <!-- 修改配置 无分组-->
              <el-row :gutter="20" :span="24" style="width: 760px">
                <!--
                  widgetType控件类型，1-文本框、2-下拉框、3-复选、4-单选、5-时间控件、6-数字 7-开关等
                  控件是否可编辑，1-可编辑，0-不可编辑
                -->
                <costomWidget
                  v-for="(item, index) in topicCodeList"
                  :key="index"
                  v-model="item.paramValue"
                  :label="item.dataName"
                  :type="`${item.widgetType}`"
                  :isEditWidget="item.isEditWidget"
                  :dicGroup="item.dicGroup"
                  :showUnit="item.showUnit"
                  :dataLen="item.dataLen"
                  :dataType="item.dataType"
                  :topicTslGroup="item.topicTslGroup"
                  width="350px"
                ></costomWidget>
              </el-row>
            </template>
          </template>
        </el-form>
      </div>
      <div class="btn-group">
        <el-button size="small" @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="previous">{{ $t('dms_firmwareTask_instruction.sybrwxx') }}</el-button>
        <el-button type="primary" @click="nextVersion">{{ $t('dms_firmwareTask_instruction.xybxzsb') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import costomWidget from '@/components/customWidget';

export default {
  props: {
    data: [String, Object, Array],
    taskId: [String, Number],
  },
  components: {
    costomWidget,
  },
  data() {
    return {
      tslCodeList: [],
      topicCodeList: [],
      // 没有分类
      otherParamList: [],
      form: {
        // 用来保存
        tslCode: '', // 用来保存
        tslId: '', // 用来查询参数
      },

      isListTsl: false,
      // list型式
      tslContent: {},
      paramTableColumn: [],
      contentList: [],
      classTslGroup: [],
      // 字典对象 用于状态修改
      dictionary: {},
    };
  },
  mounted() {
    if (this.taskId) {
      this.getTslCodeList();
    }
  },
  methods: {
    onCancel() {
      this.jump('/iot/firmwareTask');
    },
    // 将列表分为左右两组数据
    listToGroup(arr) {
      const ret = [];
      let temp = [];

      arr.forEach((item, index) => {
        if (index % 2 === 0 && index !== 0) {
          ret.push([...temp]);
          temp = [];
        }
        temp.push(item);
      });

      if (temp.length) {
        ret.push([...temp]);
      }
      return ret;
    },

    // 获取所有参数值
    getTslCodeList: function () {
      this.$getJSON(apis.commandTaskTslDataList, {
        // topicId: this.data.topicId,
        // protocolId: this.data.protocolId,
        taskId: this.taskId,
        // 新
        productCode: this.data.productCode,
        tcpVersion: this.data.tcpVersion,
        topicCode: this.data.topicCode,
      }).then((res) => {
        // list
        this.tslContent = res.data.find(i => i.dataType === 'List');
        // 为 list 的
        if (this.tslContent) {
          this.isListTsl = true;
          // 编辑合并值和新的未填入值
          const billContent = res.data.filter(i => i.dataType === 'List');
          this.billContent = billContent[0];
          const widgetTypeList = res.data.filter(i => i.dataType !== 'List');
          this.contentList = this.billContent.dataValue;
          widgetTypeList.forEach((i) => {
            // 设置表格列
            let column = {};
            column = i;
            column.columnCode = i.dataCode;
            column.columnName = i.dataName;
            column.widgetType = i.widgetType;
            this.paramTableColumn.push(column);
          });
        } else {
          // 编辑合并值和新的未填入值
          const editArr = res.data;
          editArr.forEach((item) => {
            // item.paramValue = item.dataValue ? item.dataValue : item.defaultValue || '';
            item.widgetType = item.widgetType || '1';
            // 如果有分类
            if (item.topicTslGroup && !this.classTslGroup.includes(item.topicTslGroup)) {
              this.classTslGroup.push(item.topicTslGroup);
            }
            if (`${item.widgetType}` === '5' && item.dataValue && item.dataValue.indexOf(':') > -1) {
              // 第一次查配置是:的  下发过是不带冒号的
              // 时间格式不对的话 清空
              // item.paramValue ? item.paramValue
              // 去除冒号  12:00改成1200
              item.paramValue = this.formatHhmmColonStr(item.dataValue) || '';
            } else if (`${item.widgetType}` === '7') {
            // 先取 参数值  后去默认值
              item.paramValue = item.dataValue ? item.dataValue : (item.defaultValue || '0');
            } else if (`${item.widgetType}` === '8') {
              // 日期格式不对的话 清空
              item.paramValue = this.$formateCheckyyyyMMddHHmm(item.dataValue);
            } else {
              // 先取 参数值  后去默认值
              item.paramValue = item.dataValue ? item.dataValue : (item.defaultValue || '');
            }
          });
          this.topicCodeList = editArr;
          this.otherParamList = this.topicCodeList.filter(i => !i.topicTslGroup);
          // 状态修改
          if (`${this.topicCodeList[0].commandMode}` === '2') {
            // 查字典
            this.getDictionary(`${this.topicCodeList[0].dicGroup}`, (data) => {
              this.dictionary = data[this.topicCodeList[0].dicGroup];
            });
          }
        }
      });
    },

    goBack: function () {
      this.jump('/iot/firmwareTask');
    },
    previous: function () {
      this.$emit('previous');
    },
    nextVersion: function () {
      if (!this.isListTsl) {
        // 数据转换
        this.topicCodeList.forEach((i) => {
          // i.paramKey = this.form.tslCode;
          // i.paramName = i.dataName;
          i.paramValue = i.paramValue;
          i.taskId = this.taskId;
          i.paramKey = i.dataCode;
          i.paramName = i.dataName;
          i.langParamName = i.langDataName;
          i.isPrimary = i.isPrimary;
          i.isYearKey = i.isYearKey;
          // i.tslCode = this.form.tslCode;
        });

        //

        this.saveTopicCodeList();
        // }
      } else {
        // 判断账单值不准为空
        const hasEmpty = this.contentList.find((bill) => {
          // 账单延迟日期有可能是0天
          const empty = this.paramTableColumn.find(i => !bill[i.columnCode] && bill[i.columnCode] !== 0);
          return empty;
        });

        if (hasEmpty) {
          const tips = this.$t('dms_firmwareTask_instruction.qbcstxwz');
          this.$message.error(tips);
        } else {
          // 每期重新组合格式
          this.topicCodeList = this.contentList.map((i) => {
            const obj = {};
            obj.paramKey = this.tslContent.dataCode;
            obj.paramValue = i;
            obj.paramName = this.tslContent.dataName;
            obj.dataType = this.tslContent.dataType;
            obj.tslDataId = this.tslContent.tslDataId;
            obj.tslCode = this.tslContent.tslCode;
            obj.isPrimary = this.tslContent.isPrimary;
            obj.isYearKey = this.tslContent.isYearKey;


            return obj;
          });
          this.saveTopicCodeList();
        }
      }
    },
    saveTopicCodeList() {
      this.$postJSON(apis.commandTaskParamSave, {
        taskId: this.taskId,
        // tslId: 455387929271324672,
        taskOrders: this.topicCodeList,
      }).then(() => {
        this.$emit('success', 3);
      });
    },
  },
};
</script>

<style lang="scss">
.additem-step-box {
  display: flex;
  height: 100%;
  background-color: #ffffff;
  flex-direction: column;

  .bill-list {
    // flex: 1;
    // height: 0;
    max-height: 100%;
    overflow-y: auto;
    ul li {
      // margin-top: 10px;
      // margin-bottom: 10px;
      // border: 1px solid rgba(228, 228, 228, 1);
      &:first-child {
        margin-top: 0;
      }
    }
    .rule-label {
      height: 30px;
      line-height: 30px;
      background: rgba(228, 228, 228, 1);
      color: #212121;
      font-size: 12px;
      padding: 0 10px;
    }
    .bill-item {
      padding: 5px 16px;
      // background: rgba(245, 245, 245, 1);
      border-bottom: 1px solid #eef2f8;
      color: #6c757d;
      .num {
        height: 32px;
        line-height: 32px;
      }
      .icon-box {
        line-height: 30px;
        width: 60px;
        margin-left: 10px;
        text-align: center;
        .icon {
          color: #00afff;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
    .bill-thead {
      padding: 0 16px;
      margin: 0;
      height: 44px;
      line-height: 44px;
      font-size: 12px;
      background: rgba(242, 243, 251, 1);
      // background: rgba(245, 245, 245, 1);
      border-bottom: 1px solid #eef2f8;
      font-weight: 500;
      color: rgba(99, 110, 120, 1);
      .num {
        height: 44px;
        line-height: 44px;
      }
      .icon-box {
        line-height: 43px;
        width: 60px;
        margin-left: 10px;
        text-align: center;
        .icon {
          color: #00afff;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
  }

  .title {
    // margin: 24px 24px 10px;
    padding-left: 10px;
    background: rgba(249, 200, 81, 0.15);
    border-radius: 2px;
    font-size: 12px;
    line-height: 32px;
    color: rgba(108, 117, 125, 1);
    .icon {
      color: rgba(249, 200, 81, 1);
      margin-right: 10px;
    }
  }
  .subtitle {
    font-size: 12px;
    color: #6c757d;
    line-height: 16px;
  }
  .topicCode-name {
    padding: 16px;
    font-size: 14px;
    font-weight: bold;
    color: #495057;
    line-height: 24px;
  }
  .no-radio {
    label {
      margin-right: 24px;
      .el-radio__input {
        display: none;
      }
    }
  }
}
</style>
